<div class="booking-unavailable">
  <img
    [attr.fetchpriority]="'high'"
    [ngSrc]="imgUrl"
    [priority]="true"
    alt="Just nu går det inte att boka tid online på den här mottagningen"
    height="126"
    width="160"
  >

  <h1>Just nu går det inte att boka tid online på den här mottagningen</h1>
  <p>
    Det beror på tekniska problem i vårt system. Men bara lugn – du blir inte
    utan hjälp. Du kan antingen vänta en liten stund och försöka igen, eller
    göra något av följande:
  </p>


  <div class="booking-unavailable__buttons-desktop">
    <app-ui-button (click)="onErrorReportClick()"
                   [color]="'green'"
                   [expanded]="'block'"
                   [size]="'lg'">
      Rapportera fel
    </app-ui-button>

    <app-ui-button
      (onClick)="onContactClick()"
      *ngIf="shouldDisplayButtons"
      [color]="'green'"
      [expanded]="'block'"
      [size]="'lg'"
    >
      Kontakta mottagningen
    </app-ui-button>

    <app-ui-button
      (onClick)="onSearchClick()"
      *ngIf="shouldDisplayButtons"
      [color]="'lightgreen'"
      [expanded]="'block'"
      [size]="'lg'"
    >
      Sök tider hos liknande vårdgivare
    </app-ui-button>

    <app-ui-button
      (onClick)="onCloseClick()"
      [color]="'ghost'"
      [expanded]="'block'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>

  <div class="booking-unavailable__buttons-mobile">
    <app-ui-button
      (onClick)="onContactClick()"
      *ngIf="shouldDisplayButtons"
      [color]="'green'"
      [expanded]="'block'"
      [size]="'md'"
    >
      Kontakta mottagningen
    </app-ui-button>

    <app-ui-button
      (onClick)="onSearchClick()"
      *ngIf="shouldDisplayButtons"
      [color]="'lightgreen'"
      [expanded]="'block'"
      [size]="'md'"
    >
      Sök tider hos liknande vårdgivare
    </app-ui-button>

    <app-ui-button
      (onClick)="onCloseClick()"
      [color]="'ghost'"
      [expanded]="'block'"
      [size]="'md'"
    >
      Stäng
    </app-ui-button>
  </div>
</div>
